<div [class.app-row]="!fullWidth" class="m-3 d-flex flex-column justify-content-between align-items-center">
  <div class="glyph-icon simple-icon-magnifier fa-5x text-muted m-3"></div>
  <h2 class="font-weight-bold m-1">No Results Found</h2>
  <p class="text-muted">We can't find any items matching your filters</p>
</div>
